import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Table, Row, Button, Drawer, Divider, Input, message } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import CronEdit from './crone_edit';
import CronAddEdit from './crone_addedit';
import { NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, showErrorInNotification, formatMoney } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';
import {PauseCircleFilled,PlayCircleFilled} from '@material-ui/icons';


const queryString = require('query-string');

const crone_list = ({ props, onEditPressed, onDeletePressed ,onStatusChange}) => [
    {
        title: "Crone Name",
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: "Plugin ID",
        dataIndex: 'plugin_id',
        key: 'plugin_id',
    },
    
    {
        title: "Action",
        dataIndex: 'id',
        key: 'actions',
        render: (id, data) => {
            return <div style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center'
            }}> 
                <Button type='link' onClick={() => {
                    typeof onEditPressed === 'function' && onEditPressed(data);
                }}>Edit</Button>
                <Divider type='vertical'/>
                <Button type='link' onClick={() => {
            typeof onStatusChange === 'function' && onStatusChange(data.id,{
                stop:data.stop?false:true
            });
        }}>{data.stop?<PlayCircleFilled className='success-icon' titleAccess='Tap to resume'/> : <PauseCircleFilled className='danger-icon' titleAccess='Tap to pause'/> }</Button>
                {/* <Button type='link' style={{color:'red'}} onClick={()=>{
                    typeof onDeletePressed==='function' && onDeletePressed(id);
                }}>Delete</Button> */}
            </div>
        }
    }
]
class CroneList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            add_edit_status: null,
            edit_config_id: null,
            filter_query: {}
        };

        this.list_crons = RESTExecutor.list().config({
            label: 'list',
        }).connect(props.domains.cron);

        // this.list_crons.execute();

        this.patch_fetcher_config = RESTExecutor.patch().config({
            label: 'detail',
          }).callbacks((success) => {
            message.success(success.result.message||"Update Successfull");
            this.list_crons.execute()
      
          }, (error) => {
            showErrorInNotification(error)
              }).connect(props.domains.cron);


        this.delay_search = new NetworkDelaySearch();


    };

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        let list_crons_resp = this.list_crons.response();
        let list_crons_data = list_crons_resp.result || {};
        let rowsData = list_crons_data.rows || [];
        let rowsMeta = list_crons_resp.meta || {};
        let patch_fetcher_config_resp=this.patch_fetcher_config.response();
        const { filter_query } = this.state;

        return (
            <div>
                <BasicHeader no_back title="Cron Configs"
                    menu_items={setting_quick_menu}
                    right={[
                        <TransparentButton
                            label="Add New"
                            className='cta-primary'
                            hint="Add New Cron"
                            onClick={() => {
                                this.setState({
                                    add_edit_status: 'add'
                                })
                            }}

                        />,
                    ]}

                />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                                    placeholder="Search For"
                                    style={{
                                    }}
                                    autoFocus
                                    value={filter_query.query}
                                    onChange={(e) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                                this.delay_search.onSearch(() => {
                                                    this.props.history.push({
                                                        // pathname:"users",
                                                        search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                    })
                                                })

                                            }
                                        })
                                    }}/>
                        </div>
                    </div>
                <ErrorWrapper
                error={list_crons_resp}
                onReload={()=>{
                    this.list_crons.execute()
                }}
                >

              
                <div className='default-card' style={{ padding: 0 }}>
                    <Table
                        className='main-table'
                        loading={list_crons_resp.fetching||patch_fetcher_config_resp.fetching}
                        size='small'
                        scroll={{ x: true }}
                        pagination={{
                            simple: false,
                            position: 'bottom',
                            onChange: (current, size) => {
                                this.props.history.push({
                                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                })
                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            // defaultPageSize: 20,
                            pageSize: (rowsMeta && rowsMeta.requested_count),

                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                        // bordered={false}
                        rowKey={(record) => record.id}
                        columns={crone_list({
                            onEditPressed: (data) => {
                                this.setState({
                                    edit_config_id: data.id,
                                    add_edit_status: 'edit'
                                })
                            },
                            onStatusChange:(id,data)=>{
                                this.patch_fetcher_config.forId(id).execute(data)
                            }
                        })}
                        dataSource={rowsData}
                    />

                  
                </div>
                </ErrorWrapper>
                  {/* For Fetcher Config Add */}
                  <Drawer
                        title="Cron Config Add"
                        placement="right"
                        closable={false}
                        width='50%'
                        destroyOnClose
                        onClose={() => {
                            this.setState({
                                add_edit_status: null
                            });
                            this.list_crons.execute()
                        }}
                        visible={this.state.add_edit_status === 'add'}
                    >
                        <CronAddEdit
                            onClose={() => {
                                this.setState({
                                    add_edit_status: null
                                });
                                this.list_crons.execute()
                            }}
                        // onRefreshClose={()=>{
                        //     this.list_crons.execute();
                        //     this.setState({
                        //         add_edit_status:null
                        //     })
                        // }}

                        />
                    </Drawer>
                    <Drawer
                        title="Cron Config Edit"
                        placement="right"
                        closable={false}
                        width='50%'
                        destroyOnClose
                        onClose={() => {
                            this.setState({
                                add_edit_status: null
                            });
                            this.list_crons.execute()
                        }}
                        visible={this.state.add_edit_status === 'edit'}
                    >
                        <CronEdit
                            config_id={this.state.edit_config_id}
                            onClose={() => {
                                this.setState({
                                    add_edit_status: null
                                });
                                this.list_crons.execute()
                            }}
                        // onRefreshClose={()=>{
                        //     this.list_crons.execute();
                        //     this.setState({
                        //         add_edit_status:null
                        //     })
                        // }}
                        />
                    </Drawer>
                
            </div>
        )
    }

    componentDidMount() {
        overrideHeaderTitle("Cron Configs");
        overrideHeaderBack(null);
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_crons.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })



    }
    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_crons.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }
}


export default withDomains(CroneList, "cron");
